<div class="main">
    <div class="container-fluid">
        <div class="lookups-header d-flex flex-wrap justify-content-between align-items-center m-4">
            <div class="lookups-title-container mb-3 mb-md-0">
                <h3>Lookups</h3>
                <span>
                    <a [routerLink]="['/' + AppConstants.ROUTES.HOME]" class="lookups-header-title breadcrumb-link">Dashboard <i class="lni lni-chevron-right" aria-hidden="true"></i></a>
                    <span class="lookups-header-title"> Lookups</span>
                </span>
            </div>

            <div class="d-flex align-items-end gap-3">
                <div class="lookup-type-wrapper">
                    <label for="lookup-type" class="lookup-type-label">Lookup type</label>
                    <select
                        id="lookup-type"
                        class="form-select lookup-type-select"
                        [(ngModel)]="selectedLookupType"
                        (ngModelChange)="onLookupTypeChange()">
                        <option *ngFor="let type of lookupTypes" [value]="type.value">{{ type.label }}</option>
                    </select>
                </div>
                <button class="add-btn text-white" *ngIf="canShowAddButton" (click)="openAddDialog()">
                    {{ isCategoryTree ? 'Add category' : 'Add' }}
                </button>
            </div>
        </div>

        <!-- Category Tree (special view) -->
        <app-category-tree *ngIf="isCategoryTree"></app-category-tree>

        <!-- Standard data table -->
        <ng-container *ngIf="!isCategoryTree">
            <app-data-table
                [data]="lookupData"
                [columns]="tableColumns"
                [paginator]="true"
                [rows]="10"
                [showCheckbox]="false"
                (onActionClick)="onTableActionClick($event)">
            </app-data-table>

            <p *ngIf="lookupData.length === 0" class="no-records-hint ms-4">
                No records. Click "Add" to create one.
            </p>
        </ng-container>
    </div>

    <!-- Delete Confirmation Dialog -->
    <div class="confirmation-dialog-overlay" *ngIf="showConfirmDialog" (click)="cancelDelete()">
        <div class="confirmation-dialog" (click)="$event.stopPropagation()">
            <div class="dialog-content">
                <p>Are you sure you want to delete this record?</p>
            </div>
            <div class="dialog-footer">
                <button class="btn btn-secondary" (click)="cancelDelete()">Cancel</button>
                <button class="btn action-btn-purple" (click)="confirmDelete()">Delete</button>
            </div>
        </div>
    </div>
</div>
